import FixedBundlePdpAOV from './FixedBundlePdpAOV';

export default FixedBundlePdpAOV;
